import { RENEWAL_DASHBOARD_GRAPH_DATA } from "../actions/renewalDashboardGraph.action";

const defaultState = {};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case RENEWAL_DASHBOARD_GRAPH_DATA:
      return {
        ...state,
        renewalDashboardGraphData: action.payload,
      };
  }
};

export default reducer;
